import React from 'react';
import { Box } from '@mui/material';

const DynamicPageDescription = ({ description = '' }) => {
  if (!description) return null;

  return (
    <Box sx={{ backgroundColor: '#f4f4f7', pt: { xs: 2, md: 4 }, pb: 0 }}>
      {/* Description Content */}
      <Box
        sx={{
          maxWidth: '1400px',
          margin: '0 auto',
          px: { xs: 2, sm: 3, md: 4 },
          '& .data-container, & .img_section, & .banner-overlay, & .set-style': {
            position: 'static',
            transform: 'none',
            left: 'auto',
            width: 'auto',
            height: 'auto',
            overflow: 'visible',
            background: 'transparent',
            boxShadow: 'none',
            borderRadius: 0,
            padding: 0,
            margin: 0
          },
          '& .banner-overlay, & .banner-description': {
            color: '#333'
          },
          '& .banner-title, & h2': {
            fontFamily: 'gothamBold',
            fontSize: { xs: '20px', sm: '22px', md: '24px' },
            lineHeight: 1.4,
            color: '#27306B',
            textAlign: 'center',
            margin: '0 0 16px'
          },
          '& p': {
            fontFamily: 'gothamBook',
            fontSize: { xs: '14px', sm: '15px', md: '16px' },
            lineHeight: 1.8,
            color: '#333',
            marginBottom: '12px'
          },
          '& strong': {
            fontFamily: 'gothamBold',
            color: '#27306B'
          }
        }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Box>
  );
};

export default DynamicPageDescription;
